<form *ngIf="productCode" [formGroup]="addToCartForm" (submit)="addToCart()">
  <div class="quantity" *ngIf="showQuantity">
    <ng-container *ngIf="!hideTexts">
      <label *ngIf="quantity <= 0 || quantity > maxQuantity">{{
          'addToCart.checkQuantity' | cxTranslate
        }}</label>
    </ng-container>
    <ng-container *ngIf="!hideTexts">
      <label *cxFeature="'a11yQTY2Quantity'">{{
          'addToCart.quantityFull' | cxTranslate
        }}</label>
    </ng-container>
    <ng-container *ngIf="!hideTexts">
      <label *cxFeature="'!a11yQTY2Quantity'" >{{
          'addToCart.quantity' | cxTranslate
        }}</label>
    </ng-container>
    <div class="cx-counter-stock">
      <cx-item-counter
        *ngIf="hasStock"
        [max]="maxQuantity"
        [control]="passThrought(addToCartForm.get('quantity'))"
        [ariaDescribedById]="'add-to-card-stock-info'"
      ></cx-item-counter>
      <cx-item-counter
        *ngIf="forceInStock"
        [control]="passThrought(addToCartForm.get('quantity'))"
        [ariaDescribedById]="'add-to-card-stock-info'"
      ></cx-item-counter>

      <span class="info" id="add-to-card-stock-info" *ngIf="!hideTexts">
        <span *ngIf="inventoryDisplay">{{ getInventory() }}</span>
        {{
          hasStock || forceInStock
            ? ('addToCart.inStock' | cxTranslate)
            : ('addToCart.outOfStock' | cxTranslate)
        }}
      </span>
    </div>
  </div>
  <p class="warn-over-stock" *ngIf="isDisabledByQuantityOverStock && !forceInStock && hasStock">
    {{ "gonvarri.chapa.ajustToStock" | cxTranslate }}
  </p>
  <ng-container *ngIf="hasStock || forceInStock">
    <ng-template
      [cxOutlet]="CartOutlets.ADD_TO_CART_PICKUP_OPTION"
      [(cxComponentRef)]="pickupOptionCompRef"
    ></ng-template>
  </ng-container>
  <button
    #addToCartDialogTriggerEl
    *ngIf="hasStock || forceInStock"
    [ngClass]="
      (options?.displayAddToCart
        ? 'btn btn-tertiary gonvarri-add-to-cart'
        : 'btn btn-primary btn-block gonvarri-add-to-cart')
    "
    type="submit"
    [disabled]="((quantity <= 0 || quantity > maxQuantity) && !forceInStock) || isDisabled || (isDisabledByQuantityOverStock && !forceInStock)"
  >
    <span
      *ngIf="
        options?.addToCartString === ('addToCart.buyItAgain' | cxTranslate)
      "
      class="repeat-icon"
      ><cx-icon [type]="iconTypes.REPEAT"></cx-icon
    ></span>
    <span
      [ngClass]="
        options?.addToCartString === ('addToCart.buyItAgain' | cxTranslate)
          ? 'buyItAgainLink'
          : ''
      "
    >
      <cx-icon [type]="iconTypes.CART" *ngIf="!!(options?.addToCartString)" />
      {{ (options?.addToCartString) ?? ('addToCart.addToCart' | cxTranslate) }}
    </span>
  </button>
  <app-gonvarri-product-nofification-button
    *ngIf="!forceInStock && !hasStock"
    [product]="product"
  />
</form>
